var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 21C3.5 14.4003 3.5 11.1005 5.55025 9.05025C7.60051 7 10.9003 7 17.5 7H24.5C31.0997 7 34.3995 7 36.4497 9.05025C38.5 11.1005 38.5 14.4003 38.5 21V24.5C38.5 31.0997 38.5 34.3995 36.4497 36.4497C34.3995 38.5 31.0997 38.5 24.5 38.5H17.5C10.9003 38.5 7.60051 38.5 5.55025 36.4497C3.5 34.3995 3.5 31.0997 3.5 24.5V21Z",
    stroke: "#DC143C",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 7V4.375",
    stroke: "#DC143C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.75 7V4.375",
    stroke: "#DC143C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 15.75H37.625",
    stroke: "#DC143C",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 29.75C31.5 30.7165 30.7165 31.5 29.75 31.5C28.7835 31.5 28 30.7165 28 29.75C28 28.7835 28.7835 28 29.75 28C30.7165 28 31.5 28.7835 31.5 29.75Z",
    fill: "#DC143C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5 22.75C31.5 23.7165 30.7165 24.5 29.75 24.5C28.7835 24.5 28 23.7165 28 22.75C28 21.7835 28.7835 21 29.75 21C30.7165 21 31.5 21.7835 31.5 22.75Z",
    fill: "#DC143C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 29.75C22.75 30.7165 21.9665 31.5 21 31.5C20.0335 31.5 19.25 30.7165 19.25 29.75C19.25 28.7835 20.0335 28 21 28C21.9665 28 22.75 28.7835 22.75 29.75Z",
    fill: "#DC143C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 22.75C22.75 23.7165 21.9665 24.5 21 24.5C20.0335 24.5 19.25 23.7165 19.25 22.75C19.25 21.7835 20.0335 21 21 21C21.9665 21 22.75 21.7835 22.75 22.75Z",
    fill: "#DC143C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14 29.75C14 30.7165 13.2165 31.5 12.25 31.5C11.2835 31.5 10.5 30.7165 10.5 29.75C10.5 28.7835 11.2835 28 12.25 28C13.2165 28 14 28.7835 14 29.75Z",
    fill: "#DC143C"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22.75C14 23.7165 13.2165 24.5 12.25 24.5C11.2835 24.5 10.5 23.7165 10.5 22.75C10.5 21.7835 11.2835 21 12.25 21C13.2165 21 14 21.7835 14 22.75Z",
    fill: "#DC143C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.05cb03a5f2b6e2e6ff43ea2944752386.svg";
export { ForwardRef as ReactComponent };